import produce from 'immer'

import { CLOSE_TABLE, OPEN_TABLE, SET_TABLE_LAYER, SET_TABLE_STATUS } from 'drawer/tabs/layers/table/actions'

export const table = (state = null, action) => {
  switch (action.type) {
    case OPEN_TABLE:
      return produce(state, table => {
        table.open = true
        table.titleid = action.titleid
        table.data = action.data
        table.status = 'opening'
      })
    case CLOSE_TABLE:
      return produce(state, table => {
        table.open = false
        table.titleid = ''
        table.data = null
        table.status = 'closed'
      })
    case SET_TABLE_LAYER:
      return produce(state, table => {
        table.titleid = action.titleid
      })
    case SET_TABLE_STATUS:
      console.log('LayerTable status', action.status)
      return produce(state, table => {
        table.status = action.status
      })
    default:
      return state
  }
}
